<!--
Notification component
Usage: <NotifItem title="text" body="text" icon="fa-name" link="url" />
@author ab557z
-->
<template>
<div>

  <div style="border:0px;" class="eventDiv eventBox">

    <img :src="getImage(category)"  class="eventBg" />
    <span>
      <h5 style="margin-top:8px;" class="eventHeaderN">{{ title }}</h5>
    </span>

    <p v-if="description" class="clubInfo">{{ description }}</p>
    <span class="purpleLink">
    {{ category }}
    </span><br><br>
     <button  @click="goExt(assocLink)" class="clubFindBtn">Visit {{defineUnion(category)}} listing</button>
     <button v-if="website" @click="goExt(website)" class="clubFindBtn">Visit club website</button>
    <br>
    <span class="eventSocialN" v-if="twitter || facebook || instagram || email">
      <a v-if="email" style="margin-bottom:4px;margin-right:16px;" class="blueLink"  :href="'mailto:' + email">{{ email }}</a>
      <img style="margin-right:16px;" v-if="twitter" @click="goExt(twitter)" src="@/assets/social/twitter.svg" />
      <img style="margin-right:16px;" v-if="facebook" @click="goExt(facebook)" src="@/assets/social/facebook.svg" />
      <img v-if="instagram" @click="goExt(instagram)" src="@/assets/social/instagram.svg" />

    </span>

  </div>
</div>

</template>

<script>

export default {
  name: 'ExpandedClub',
  props: ['id', 'title', 'email', 'category', 'description', 'facebook', 'twitter', 'instagram',
    'website', 'assocLink'],
  data () {
    return {
    }
  },
  computed: {
    chooseCategory: function () {
      if (this.category == 'Sport') { return 'sportCategory' }
      return 'clubCategory'
    }
  },
  mounted () {

  },
  methods: {
    getImage (cat) {
      var images = require.context('@/assets/clubs/', false, /\.svg$/)
      return images('./' + cat + '.svg')
    },
    goExt (link) {
      console.log('going to ' + link)
      window.open(link, '_blank').focus()
    },
    defineUnion (cat) {
      if (cat == 'Sport') { return 'GUSA' }
      return 'SRC'
    }
  }
}
</script>
<style>
.clubInfo {
  color: #757575;
  margin-top:16px;
  font-size:18px;
}
.clubFindBtn {
  background-color:#003865;
  width:100%;
  color:#ffffff;
  font-family:PTSans;
  border: 1px solid #003865;
  border-radius:12px;
  height:52px;

  margin-bottom:21px;
  font-weight:700;
}

.eventBasis {
  font-size: 16px;
  color: #0A3875;
  padding-left:48px;
  padding-right:8%;
  margin-top:0px;
  margin-bottom:8px;
}

.eventCapacity {
  margin-top:0px;
  margin-bottom:0px;
  padding-left:48px;
  color: #828282;
}
.eventInfo {
  padding-left:48px;
  color: #828282;
}

.eventSocialN {
  display:inline-block;
  padding-bottom:20px;
}

.eventSocial img {
  margin-right:8px;
  margin-left:0px;
}

.notificationIcon {
  z-index:999;
  position:absolute;
  color:#ffffff;
}

.notifBox {
border: 1px solid #DADADA;
box-sizing: border-box;
border-radius: 8px;
}

.notifDiv {
  margin-bottom:12px;
  padding:16px;
  padding-bottom:0px;
  padding-top:8px;
  position:relative;
}

.notifBg {
  position:absolute;
  left:10px;
  top:10px;
  z-index:-1;
}

.eventBody {
  font-size: 16px;
  color: #0A3875;
  padding-left:48px;
  padding-right:8%;
  display:inline-block;
  margin-bottom:0px;
}

.eventHeader {
  font-style: normal;
  display:inline-block;
  padding-left:48px;
  font-weight: bold;
  font-size: 16px;
  line-height:21px;
  color: #0A3875;
}
</style>
